import { ensure, TType } from "types";

import { consultantProfileType, IConsultantProfile } from "@/data/consultant-profiles";
import { configInvitationType, IInvitation, IInvitationDto } from "@/data/invitations";

export interface IManagerInvitation extends IInvitation {
  consultantProfile: IConsultantProfile;
}

const configManagerInvitationType: TType<IManagerInvitation> = {
  ...configInvitationType,
  consultantProfile: consultantProfileType,
};

export const managerInvitationType = ensure(configManagerInvitationType);

export interface IManagerInvitationDto extends IInvitationDto {}
